<div class="py-4 px-0">
  <div class="container">
    <h1>{{ "forms.editEducationalResource.title" | translate }}</h1>

    <ul class="list-inline material-form-tabs">
      <li class="list-inline-item">
        <a [routerLink]="['/muokkaa-oppimateriaalia', educationalMaterialID, 1]" routerLinkActive="active">
          {{ "forms.educationalResource.nav.files" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/muokkaa-oppimateriaalia', educationalMaterialID, 2]" routerLinkActive="active">
          {{ "forms.educationalResource.nav.basicDetails" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/muokkaa-oppimateriaalia', educationalMaterialID, 3]" routerLinkActive="active">
          {{ "forms.educationalResource.nav.educationalDetails" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/muokkaa-oppimateriaalia', educationalMaterialID, 4]" routerLinkActive="active">
          {{ "forms.educationalResource.nav.extendedDetails" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/muokkaa-oppimateriaalia', educationalMaterialID, 5]" routerLinkActive="active">
          {{ "forms.educationalResource.nav.licenseDetails" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/muokkaa-oppimateriaalia', educationalMaterialID, 6]" routerLinkActive="active">
          {{ "forms.educationalResource.nav.basedOnDetails" | translate }}
        </a>
      </li>

      <li class="list-inline-item divider" aria-hidden="true">
        <img src="assets/img/icons/ic_arrow_right_black.svg" alt="divider arrow" />
      </li>

      <li class="list-inline-item">
        <a [routerLink]="['/muokkaa-oppimateriaalia', educationalMaterialID, 7]" routerLinkActive="active">
          {{ "forms.educationalResource.nav.preview" | translate }}
        </a>
      </li>
    </ul>

    @if ((educationalMaterialEditForm$ | async); as editForm) {
      @switch (tabId) {
        @case (1) {
          <app-tabs-edit-files
            [tabId]="1"
          (abortEdit)="openConfirmModal(confirmAbort)"></app-tabs-edit-files>
        }
        @case (2) {
          <app-tabs-edit-basic-details
            [material]="editForm"
            [materialId]="educationalMaterialID"
            [tabId]="2"
          (abortEdit)="openConfirmModal(confirmAbort)"></app-tabs-edit-basic-details>
        }
        @case (3) {
          <app-tabs-edit-educational-details
            [material]="editForm"
            [materialId]="educationalMaterialID"
            [tabId]="3"
          (abortEdit)="openConfirmModal(confirmAbort)"></app-tabs-edit-educational-details>
        }
        @case (4) {
          <app-tabs-edit-extended-details
            [material]="editForm"
            [materialId]="educationalMaterialID"
            [tabId]="4"
          (abortEdit)="openConfirmModal(confirmAbort)"></app-tabs-edit-extended-details>
        }
        @case (5) {
          <app-tabs-edit-license
            [material]="editForm"
            [materialId]="educationalMaterialID"
            [tabId]="5"
          (abortEdit)="openConfirmModal(confirmAbort)"></app-tabs-edit-license>
        }
        @case (6) {
          <app-tabs-edit-based-on-details
            [material]="editForm"
            [materialId]="educationalMaterialID"
            [tabId]="6"
          (abortEdit)="openConfirmModal(confirmAbort)"></app-tabs-edit-based-on-details>
        }
        @case (7) {
          <app-tabs-edit-preview
            [tabId]="7"
            [materialId]="educationalMaterialID"
          (abortEdit)="openConfirmModal(confirmAbort)"></app-tabs-edit-preview>
        }
        <!--        [material]="editForm"-->
      }
    }
  </div>
</div>

<ng-template #confirmAbort>
  <div class="modal-body text-center">
    <p>{{ "forms.editEducationalResource.abort.text" | translate }}</p>
    <button type="button" class="btn btn-blue" (click)="abort()">
      {{ "forms.editEducationalResource.abort.confirm" | translate }}
    </button>
    <button type="button" class="btn btn-outline-blue" (click)="confirmModalRef.hide()">
      {{ "forms.editEducationalResource.abort.cancel" | translate }}
    </button>
  </div>
</ng-template>
